import { getActiveSplat } from "./splats.js";

const activeSplat = getActiveSplat();

export default [
    {
        name: "splat",
        type: "ply",
        path: activeSplat.path,
    },
];
